/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArchiveBoxIcon32Regular = forwardRef('ArchiveBoxIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { d: "M11 17a1 1 0 0 1 1-1h8a1 1 0 1 1 0 2h-8a1 1 0 0 1-1-1Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.5 4A2.5 2.5 0 0 0 2 6.5v4a2.5 2.5 0 0 0 2 2.45V24.5A4.5 4.5 0 0 0 8.5 29h15a4.5 4.5 0 0 0 4.5-4.5V12.95a2.5 2.5 0 0 0 2-2.45v-4A2.5 2.5 0 0 0 27.5 4h-23ZM26 13H6v11.5A2.5 2.5 0 0 0 8.5 27h15a2.5 2.5 0 0 0 2.5-2.5V13Zm1.5-2a.5.5 0 0 0 .5-.5v-4a.5.5 0 0 0-.5-.5h-23a.5.5 0 0 0-.5.5v4a.5.5 0 0 0 .5.5h23Z" })));
});
